
import eventBus from '@/plugins/eventBus'
import { Component, Vue } from 'vue-property-decorator'
import router from '@/router'

@Component({
  components: {},
})
export default class EmojiFeedback extends Vue {
  loadFeedback(id) {
    eventBus.$emit('feedback-received', id)
  }

  goBack() {
    router.go(-1)
  }
}
